import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-he_004",
  "use": "icon-he_004-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-he_004\"><defs><style>#icon-he_004 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-he_004_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-he_004_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"18 21 14 21 14 17 10 17 10 21 6 21 6 14 2 14 12 3 22 14 18 14 18 21\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol